<template>
  <span
    v-if="variant === 'stat'"
    class="d-inline-flex justify-content-center align-items-end"
  >
    <span class="h3 mx-2 mb-0 fs-6">{{ amountText }}</span>
    <span class="fs-9 text-muted">{{ currencyLabel(currency) }}</span>
  </span>
  <span v-else class="fw-bold">
    {{ amountText }} {{ currencyLabel(currency) }}
  </span>
</template>

<script setup lang="ts">
import { currencyLabel, formatMoney } from "@/composables/formatUtils";
import type { Currency } from "@/money/currency_constants";
import { computed } from "vue";

/**
 * One amount of a "Money pending" figure with its currency label: `stat` sets the unit beside the
 * number, `summary` is a single bold line. A null amount reads "-".
 */
const props = defineProps<{
  amount: number | null;
  currency: Currency;
  variant: "stat" | "summary";
}>();

const amountText = computed(() =>
  props.amount === null ? "-" : formatMoney(props.amount)
);
</script>
